import { SessionSelectors } from '@next/core-lib/session';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AppState, ArableSessionState } from '../shared/models/app.model';

export const selectApp = createFeatureSelector<AppState>('app');

export const getAvailableCropYears = createSelector(
  selectApp,
  (store) => store?.availableCropYears ?? [],
);

export const getDefaultCropYear = createSelector(selectApp, (store) => store?.defaultCropYear);

export const selectArableSession = createSelector(
  SessionSelectors.selectSessionState,
  (session: ArableSessionState) => session?.arable,
);

export const getCropYear = createSelector(
  selectArableSession,
  getDefaultCropYear,
  (arable, defaultCropYear) => arable?.cropYear ?? defaultCropYear,
);

export const isPreviousCropYear = createSelector(
  selectArableSession,
  getDefaultCropYear,
  (arable, defaultCropYear) => (arable?.cropYear ?? defaultCropYear) < new Date().getFullYear(),
);
